const BASE_URL = 'https://oa.hansenzy.com'
const BASE_URL_2971 = 'https://pc.hansenzy.com'
const BASE_FILE = 'https://oa.hansenzy.com/msi/base/file/upload'
const BASE_ACL = 'https://oa.hansenzy.com/msi/base/acl'
const BASE_DMZ = 'https://oa.hansenzy.com/dmz/base/acl'
const BASE_INFO = 'https://oa.hansenzy.com/msi/base/info'
const DMZ_BASE = 'https://oa.hansenzy.com/dmz/base/info'
const PMC_INFO = 'https://oa.hansenzy.com/msi/pmc/info'
const CMC_BASE = 'https://oa.hansenzy.com/msi/cmc/base'
const BASE_MCC = 'https://oa.hansenzy.com/msi/mcc/campaign'
const IMS_INFO = 'https://oa.hansenzy.com/msi/ims/info'
const IMS_ORDER = 'https://oa.hansenzy.com/msi/ims/order'
const IMS_STOCK = 'https://oa.hansenzy.com/msi/ims/stock'
const MMC_INFO = 'https://oa.hansenzy.com/msi/mmc/info'
const MMC_CAMPAIGN = 'https://oa.hansenzy.com/msi/mmc/campaign'
const CMS_BASE = 'https://oa.hansenzy.com/msi/cms/web'
const WECHAT_INFO = 'https://oa.hansenzy.com/msi/wechat/info'
const WECHAT = 'https://oa.hansenzy.com/msi/wechat'
const EURLATE_MEMBER = 'https://oa.hansenzy.com/msi/mmc/eurlate'
const EURLATE_MEMBER_DESC = 'https://oa.hansenzy.com/msi/mmc/campaign'
const MYG_1V1 = 'https://oa.hansenzy.com/msi/myg/1v1'
const MMC_GIFT = 'https://oa.hansenzy.com/msi/mmc/gift'
// 127.0.0.1:7511
const DATA_DICT = { // 数据字典
  payStatus: { // 支付状态
    '10': 'Unpaid',
    '20': 'PartialPayment',
    '50': 'Paid'
  },
  orderStatus: {
    '20': 'PendingApproval',
    '25': 'Refused',
    '30': 'Deleted',
    '40': 'AdminCancel',
    '45': 'CustomCancel',
    '50': 'Undelivered',
    '60': 'PartialDeliver',
    '70': 'Delivered',
    '80': 'Recovered',
    '90': 'Completed'
  },
  deliverStatus: {
    '10': 'Undelivered',
    '20': 'ToAudit',
    '25': 'Refused',
    '40': 'PartialDeliver',
    '50': 'Delivered'
  },
  targetType: {
    'agent': 'D',
    'member': 'M',
    'designer': 'D'
  },
  stockStatus: {
    '20': 'ToAudit',
    '25': 'notPass',
    '50': 'Passed'
  }
}

export default{
  FILE_PRE: 'http://hs.hengyon.com:13097/filePreview.html',
  BASE_URL,
  BASE_URL_2971,
  BASE_FILE,
  BASE_ACL,
  BASE_DMZ,
  BASE_INFO,
  DMZ_BASE,
  PMC_INFO,
  CMC_BASE,
  IMS_INFO,
  IMS_STOCK,
  BASE_MCC,
  IMS_ORDER,
  MMC_INFO,
  CMS_BASE,
  DATA_DICT,
  WECHAT_INFO,
  EURLATE_MEMBER,
  EURLATE_MEMBER_DESC,
  WECHAT,
  MMC_CAMPAIGN,
  MYG_1V1,
  MMC_GIFT
}



// WEBPACK FOOTER //
// ./src/constants/Global.constants.js